import { EmptyState, NoTasksIcon } from '@bp/ui-components';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { BpHeader } from 'components/BpHeader/BpHeader';
import { useRequireParams } from 'hooks/useRequireParams';
import { useTranslation } from 'react-i18next';
import { AssignmentCardTeacher } from '../AssignmentCard/AssignmentCardTeacher';
import styles from './AssignmentPreview.module.scss';

type AssignmentPreviewTeacherProps = {
  loading: string | null;
  onNavigate: (uuid: string) => void;
  onEdit: (uuid: string) => void;
  onDelete: (uuid: string) => void;
};

export const AssignmentPreviewTeacher = ({ loading, onNavigate, onEdit, onDelete }: AssignmentPreviewTeacherProps) => {
  const { t } = useTranslation();
  const { courseUuid } = useRequireParams(['courseUuid']);

  const { activeAssignments } = useAssignments({ courseUuid });

  return (
    <div className={styles['assignment-preview']}>
      <BpHeader headline={t('assignments.active')} subHeadline={activeAssignments.length} showSubHeadlineAsChip />
      {activeAssignments.length === 0 ? (
        <EmptyState
          size='small'
          backgroundColor='var(--color-white)'
          subtitle={t('assignments.noAssignments')}
          icon={<NoTasksIcon />}
          forcedWidth='300px'
          forcedHeight='164px'
        />
      ) : (
        <div className={styles.assignments}>
          {activeAssignments.map((assignment) => (
            <AssignmentCardTeacher
              key={assignment.uuid}
              assignmentUuid={assignment.uuid}
              loading={!!loading && loading === assignment.uuid}
              onNavigate={(uuid) => onNavigate(uuid)}
              onEdit={(uuid) => onEdit(uuid)}
              onDelete={(uuid) => onDelete(uuid)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
